import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { returnsListRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE, IRoleEnum.STORE_EMPLOYEE];

const returnsListRouteMetadata: IRouteMetadataObj<typeof returnsListRoutesObj> =
  {
    list: {
      title: "salesManagement.index.title",
      description: "empty",
      lazy: () => import("@pages/salesManagement/returnsList/table/page"),
      mode: "index",
      type: "main",
      icon: "MoneyDollarCircleLine",
      breadcrumbs: [],
      permission,
    },
    restoreGoods: {
      title: "salesManagement.returnsList.restoreOfGoods.title",
      description: "empty",
      lazy: () => import("@pages/salesManagement/restoreGoods/page"),
      mode: "create",
      type: "inner",
      icon: "RestartLine",
      breadcrumbs: [],
      permission,
      pageState: { noPadding: true, actionType: "back" },
    },
  };

export const returnsListRoutes = createRoute<typeof returnsListRoutesObj>(
  returnsListRoutesObj,
  returnsListRouteMetadata,
);
